import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Icon, Tooltip, createUseStyles, useTheme } from '@Sage/hoi-poi-ui';
import classNames from 'classnames';
import LottieGif from 'components/LottieGif';

import styles, { CIRCLE_CIRCUMFERENCE, CIRCLE_R } from './styles';

const GLOW_LOTTIE =
    '{"nm":"Flow 1","ddd":0,"h":80,"w":80,"meta":{"g":"LottieFiles Figma v69"},"layers":[{"ty":4,"nm":"Ellipse 6","sr":1,"st":0,"op":121.3,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[15,15],"t":0},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[15,15],"t":24},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[15,15],"t":48},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[15,15],"t":72},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[15,15],"t":96},{"s":[15,15],"t":120}]},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100,100],"t":0},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100,100],"t":24},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100,100],"t":48},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100,100],"t":72},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100,100],"t":96},{"s":[100,100],"t":120}]},"sk":{"a":0,"k":0},"p":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[40,40],"t":0},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[44,36],"t":24},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[44,44],"t":48},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[36,44],"t":72},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[36,36],"t":96},{"s":[40,40],"t":120}]},"r":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":0},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":24},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":48},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":72},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":96},{"s":[0],"t":120}]},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":0},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":24},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":48},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":72},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":96},{"s":[100],"t":120}]}},"ef":[{"ty":29,"nm":"","en":1,"ef":[{"ty":0,"nm":"sigma","v":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[25],"t":0},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[25],"t":24},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[25],"t":48},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[25],"t":72},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[25],"t":96},{"s":[25],"t":120}]}},{"ty":0,"nm":"","v":{"a":0,"k":1}},{"ty":0,"nm":"","v":{"a":0,"k":0}}]}],"shapes":[{"ty":"sh","bm":0,"hd":false,"nm":"","d":1,"ks":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[{"c":true,"i":[[0,0],[8.28,0],[0,8.28],[-8.28,0],[0,-8.28]],"o":[[0,8.28],[-8.28,0],[0,-8.28],[8.28,0],[0,0]],"v":[[30,15],[15,30],[0,15],[15,0],[30,15]]}],"t":0},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[{"c":true,"i":[[0,0],[8.28,0],[0,8.28],[-8.28,0],[0,-8.28]],"o":[[0,8.28],[-8.28,0],[0,-8.28],[8.28,0],[0,0]],"v":[[30,15],[15,30],[0,15],[15,0],[30,15]]}],"t":24},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[{"c":true,"i":[[0,0],[8.28,0],[0,8.28],[-8.28,0],[0,-8.28]],"o":[[0,8.28],[-8.28,0],[0,-8.28],[8.28,0],[0,0]],"v":[[30,15],[15,30],[0,15],[15,0],[30,15]]}],"t":48},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[{"c":true,"i":[[0,0],[8.28,0],[0,8.28],[-8.28,0],[0,-8.28]],"o":[[0,8.28],[-8.28,0],[0,-8.28],[8.28,0],[0,0]],"v":[[30,15],[15,30],[0,15],[15,0],[30,15]]}],"t":72},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[{"c":true,"i":[[0,0],[8.28,0],[0,8.28],[-8.28,0],[0,-8.28]],"o":[[0,8.28],[-8.28,0],[0,-8.28],[8.28,0],[0,0]],"v":[[30,15],[15,30],[0,15],[15,0],[30,15]]}],"t":96},{"s":[{"c":true,"i":[[0,0],[8.28,0],[0,8.28],[-8.28,0],[0,-8.28]],"o":[[0,8.28],[-8.28,0],[0,-8.28],[8.28,0],[0,0]],"v":[[30,15],[15,30],[0,15],[15,0],[30,15]]}],"t":120}]}},{"ty":"fl","bm":0,"hd":false,"nm":"","c":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0.8235,0.9725,0.8627],"t":0},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0.8235,0.9725,0.8627],"t":24},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0.8235,0.9725,0.8627],"t":48},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0.8235,0.9725,0.8627],"t":72},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0.8235,0.9725,0.8627],"t":96},{"s":[0.8235,0.9725,0.8627],"t":120}]},"r":1,"o":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":0},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":24},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":48},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":72},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":96},{"s":[100],"t":120}]}}],"ind":1}],"v":"5.7.0","fr":60,"op":120.3,"ip":0,"assets":[]}';

const useStyles = createUseStyles(styles, 'CopilotChatButton');

const DEFAULT_TIMER_DURATION_MS = 2000;

const ChatButton = memo(
    ({
        className = '',
        hasGlow = false,
        iconName,
        iconColor,
        isDisabled = false,
        onClick,
        showTimer = false,
        timerCallback,
        timerDuration = DEFAULT_TIMER_DURATION_MS,
        tooltip,
    }) => {
        // ========================================
        // CONTEXT & CUSTOM HOOKS
        // ========================================
        const classes = useStyles();
        const theme = useTheme();

        // ========================================
        // LOCAL STATE
        // ========================================
        const [isHovered, setIsHovered] = useState(false);

        // ========================================
        // REFS
        // ========================================
        const circleRef = useRef(null);
        const rafIdRef = useRef(null);
        const cancelledRef = useRef(false);
        const timerCallbackRef = useRef(timerCallback);
        timerCallbackRef.current = timerCallback;

        // ========================================
        // DERIVED STATE & MEMOIZATION
        // ========================================
        const iconProps = useMemo(
            () => ({
                className: classes.icon,
                color: iconColor ?? theme.colors.primary.black,
                name: iconName,
                size: 'large',
            }),
            [classes.icon, iconColor, iconName, theme.colors.primary.black],
        );

        // ========================================
        // EVENT HANDLERS & CALLBACKS
        // ========================================
        const handleClick = useCallback(
            (e) => {
                e.stopPropagation();
                if (!isDisabled && onClick) {
                    onClick(e);
                }
            },
            [isDisabled, onClick],
        );

        const handleMouseEnter = useCallback(() => {
            if (!isDisabled) {
                setIsHovered(true);
            }
        }, [isDisabled]);

        const handleMouseLeave = useCallback(() => {
            setIsHovered(false);
        }, []);

        // ========================================
        // EFFECTS – timer border animation (RAF)
        // ========================================
        useEffect(() => {
            if (!showTimer || isHovered) {
                cancelledRef.current = true;
                if (rafIdRef.current != null) {
                    cancelAnimationFrame(rafIdRef.current);
                    rafIdRef.current = null;
                }
                if (circleRef.current) {
                    circleRef.current.setAttribute(
                        'stroke-dashoffset',
                        String(CIRCLE_CIRCUMFERENCE),
                    );
                }
                return;
            }

            cancelledRef.current = false;
            let startTime = null;
            const duration = timerDuration;
            const circle = circleRef.current;

            if (circle) {
                circle.setAttribute('stroke-dashoffset', String(CIRCLE_CIRCUMFERENCE));
            }

            const tick = (now) => {
                if (cancelledRef.current) return;
                if (!circleRef.current) {
                    rafIdRef.current = requestAnimationFrame(tick);
                    return;
                }
                if (startTime == null) {
                    startTime = now;
                    circleRef.current.setAttribute(
                        'stroke-dashoffset',
                        String(CIRCLE_CIRCUMFERENCE),
                    );
                }
                const elapsed = now - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const offset = CIRCLE_CIRCUMFERENCE * (1 - progress);
                circleRef.current.setAttribute('stroke-dashoffset', String(offset));

                if (progress >= 1) {
                    timerCallbackRef.current?.();
                    return;
                }
                rafIdRef.current = requestAnimationFrame(tick);
            };

            rafIdRef.current = requestAnimationFrame(tick);

            return () => {
                cancelledRef.current = true;
                if (rafIdRef.current != null) {
                    cancelAnimationFrame(rafIdRef.current);
                    rafIdRef.current = null;
                }
                if (circle) {
                    circle.setAttribute('stroke-dashoffset', String(CIRCLE_CIRCUMFERENCE));
                }
            };
        }, [showTimer, isHovered, timerDuration]);

        const divProps = useMemo(
            () => ({
                className: classNames(classes.root, className, {
                    [classes.disabled]: isDisabled,
                    [classes.hover]: isHovered && !isDisabled,
                }),
                onClick: handleClick,
                onMouseEnter: handleMouseEnter,
                onMouseLeave: handleMouseLeave,
            }),
            [
                classes.disabled,
                classes.hover,
                classes.root,
                className,
                handleClick,
                handleMouseEnter,
                handleMouseLeave,
                isDisabled,
                isHovered,
            ],
        );

        const showGlow = useMemo(() => {
            return hasGlow && !isHovered && !isDisabled;
        }, [hasGlow, isHovered, isDisabled]);

        // ========================================
        // RENDER
        // ========================================
        return (
            <Tooltip
                content={tooltip ? <span style={{ whiteSpace: 'nowrap' }}>{tooltip}</span> : null}
                placement="topRight"
            >
                <div {...divProps}>
                    <svg className={classes.borderProgress} viewBox="0 0 40 40" aria-hidden>
                        <circle ref={circleRef} cx="20" cy="20" r={CIRCLE_R} />
                    </svg>
                    <Icon {...iconProps} />
                    {showGlow && <LottieGif width={80} height={80} src={GLOW_LOTTIE} />}
                </div>
            </Tooltip>
        );
    },
);

ChatButton.propTypes = {
    className: PropTypes.string,
    hasGlow: PropTypes.bool,
    iconColor: PropTypes.string,
    iconName: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    showTimer: PropTypes.bool,
    timerCallback: PropTypes.func,
    timerDuration: PropTypes.number,
    tooltip: PropTypes.string,
};

export default ChatButton;
